import Map from 'react-map-gl';
import { useState } from 'react';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';
import { styled, useTheme } from '@mui/material/styles';

import { MAPBOX_API } from 'src/config-global';

import Iconify from 'src/components/iconify';
import { MapPopup, MapMarker, MapControl } from 'src/components/map';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  zIndex: 0,
  height: 560,
  overflow: 'hidden',
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  '& .mapboxgl-ctrl-logo, .mapboxgl-ctrl-bottom-right': {
    display: 'none',
  },
}));

// ----------------------------------------------------------------------

export default function ContactMap({ contacts }) {
  const theme = useTheme();

  const lightMode = theme.palette.mode === 'light';

  const [popupInfo, setPopupInfo] = useState(null);

  return (
    <StyledRoot sx={{ height: { xs: 400, md: 560 } }}>
      <Map
        initialViewState={{
          latitude: 12.9105,
          longitude: 77.6239,
          zoom: 14,
        }}
        mapStyle={`mapbox://styles/mapbox/${lightMode ? 'light' : 'dark'}-v10`}
        mapboxAccessToken={MAPBOX_API}
      >
        <MapControl hideGeolocateControl />
        {contacts.map((country, index) => (
          <MapMarker
            key={index}
            latitude={country.latlng[0]}
            longitude={country.latlng[1]}
            icon={<Iconify icon="ic:outline-location-on" color="#FF5252" />}
            onClick={(event) => {
              event.originalEvent.stopPropagation();
              setPopupInfo(country);
            }}
          />
        ))}

        {popupInfo && (
          <MapPopup
            longitude={popupInfo.latlng[1]}
            latitude={popupInfo.latlng[0]}
            onClose={() => setPopupInfo(null)}
            sx={{
              '& .mapboxgl-popup-content': {
                bgcolor: 'background.paper',
                borderRadius: 2,
                p: 2,
              },
            }}
          >
            <Typography variant="subtitle2" gutterBottom>
              Address
            </Typography>
            <Typography variant="body2">{popupInfo.address}</Typography>
            <Typography variant="body2" sx={{ mt: 1, display: 'flex', alignItems: 'center' }}>
              <Iconify icon="solar:phone-bold" width={14} sx={{ mr: 0.5 }} />
              {popupInfo.phoneNumber}
            </Typography>
          </MapPopup>
        )}
      </Map>
    </StyledRoot>
  );
}

ContactMap.propTypes = {
  contacts: PropTypes.array,
};
